<template>
  <div class="payment-credit-card">
    <div class="field">
      <p class="control has-icons-left has-icons-right">
        <input class="input" :class="{ 'is-danger': isInvalidEmail }" type="email" :placeholder="$t('commerce.email')"
          v-model="email" @blur="validateEmail" />
        <span class="icon is-small is-left">
          <i class="far fa-envelope" />
        </span>
        <span class="icon is-small is-right">
          <i class="fas fa-check" />
        </span>
      </p>
    </div>

    <stripe-elements ref="elementsRef" :pk="publishableKey" :amount="price" :styleObject="stripeCSS" locale="auto"
      @token="tokenCreated" @loading="loading = $event" />

    <div v-if="showSubmit" style="margin-top: -10px">
      <p class="button is-fullwidth is-primary" @click="submit">
        {{ $t("payment.pay-now") }}
      </p>
      <p v-if="error" class="api-error has-text-danger">{{ error }}</p>
    </div>
    <div v-else>
      <p v-if="loading" class="submit-hint">
        <i class="fa fa-spinner fa-spin has-text-info" style="margin-right: 6px" />
        We are processing your payment, please stay on this page
      </p>
    </div>
  </div>
</template>

<script>
import { StripeElements } from "vue-stripe-checkout";

export default {
  name: "PaymentCreditCard",
  components: {
    StripeElements,
  },
  props: {
    refNumber: String, // reference number for the order
    business: Object,
    price: Number,
  },
  data() {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_KEY,
      loading: false,
      debounceBtn: false,
      error: null, // api error message
      loader: null,
      email: null, // email address
      isInvalidEmail: false,
      stripeCSS: {
        base: {
          fontFamily: '"Avenir", Helvetica, Arial, sans-serif',
          fontSize: "16px",
          fontWeight: 400,
          "::placeholder": { color: "#bbb" },
        },
      },
    };
  },
  computed: {
    reference() {
      var iso = new Date().toISOString().split("T")[0].replace(/-/g, "");
      return `${this.business.name} #${iso}-${this.refNumber}`; // ${user}`;
    },
    showSubmit() {
      return !this.loading && !this.debounceBtn;
    },
    currency() {
      if (this.business.country === "sg") return "sgd";
      return "thb"; // default currency
    },
  },
  methods: {
    submit() {
      this.log("stripe_submit_card");
      if (this.validateEmail()) return;
      //   this.loader = this.loadingDots("green");
      this.error = null;
      this.debounceBtn = true;
      setTimeout(() => (this.debounceBtn = false), 2000);
      this.$refs.elementsRef.submit();
    },
    validateEmail() {
      // simplest possible email validation https://stackoverflow.com/questions/4964691/super-simple-email-validation-with-javascript
      if (/^.+@.+\..+$/.test(this.email)) {
        this.isInvalidEmail = false;
        this.error = null;
        return false; // is valid
      }
      this.isInvalidEmail = true;
      this.error = "Please provide a valid email address";
      return true; // means invalid
    },
    tokenCreated(token) {
      var priceCents = this.price * 100;
      var charge = {
        token: token.id,
        amount: priceCents, // amount to charge the customer in cents. $100 is 1000 (calculate this on the backend to avoid people manipulating the cost)
        currency: this.currency,
        description: this.reference, // optional description that will show in stripe dashboard
        email: this.email, // should also save email to user
        user_id: this.userID(),
        mobile: this.$store.getters.phoneNumber,
        business_id: this.business.id,
      };
      this.sendTokenToServer(charge);
    },
    sendTokenToServer(charge) {
      var loader = this.loadingDots(this.bulmaColor("info"));
      this.$store
        .dispatch("createStripeCharge", charge)
        .then((res) => {
          console.log("stripe charge", res.data);
          this.log("stripe_charge_success");
          this.warningToast("Payment Success");
          this.$emit("submit", res.data.id); // pass the charge ID back through to transaction obj
        })
        .catch((err) => {
          console.log("stripe charge error", err.response, err);
          if (err.response && err.response.data.message) {
            this.error = err.response.data.message;
            this.log("stripe_charge_error", err.response.data.message);
          }
          else this.apiError(err);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.submit-hint {
  color: #882;
  font-style: italic;
  margin-bottom: 12px;
}

.api-error {
  margin-top: 12px;
}

.input {
  height: 40px;
  /* padding-left: 2em; */
}

.icon {
  font-size: 1.1em;
  margin: 1px;
}

.icon.is-left {
  margin-right: 10px;
}

.has-icons-left .input {
  padding-left: 42px;
}
</style>

<style lang="scss">
#card-errors {
  margin-top: 6px;
  color: rgb(232, 66, 66);
}
</style>